module.exports = __webpack_public_path__ + "static/media/WoundsThreshold.9009fefd.svg";